import { Outlet } from "react-router-dom";
import AppShell from "components/app/AppShell";

const MyApplicationsLayout = () => {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
};

export default MyApplicationsLayout;
